import React, { useState } from 'react';
import menu from '../../assets/menu.svg';
import logo from '../../assets/logo.svg';
import logOutIcon from '../../assets/logoutIcon.svg';
import menuCrossIcon from '../../assets/menuCrossIcon.svg';
import { Button, CommonModal } from 'fluent-components';
import { useAuth } from '../Authenticate';
import {  onlyValidatorsHaveCheckResultAllowed, onlyReviewerHaveCheckResultAllowed  } from '@/lib/utils';
import { mixPanelServiceInstance } from '@/analytics/mixpanel';
import { mixPanelEvents } from '@/analytics/mixpanel/events';
import { Loader } from 'lucide-react';
import { UserInfo } from '../Authenticate/useUserInfo';

interface HeaderProps {
  userInfo?: UserInfo;
  userPermissions: string[];
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({
  userInfo,
  userPermissions,
  isDrawerOpen,
  setIsDrawerOpen,
}) => {
  const [modal, setModal] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const { logout } = useAuth();
  const isValidator = onlyValidatorsHaveCheckResultAllowed(userPermissions);
  const isReviewer = onlyReviewerHaveCheckResultAllowed(userPermissions);
  const onLogout = () => {
    setModal(true);
    if (userInfo) executeMixPanelEvents(userInfo);
  };

  const executeMixPanelEvents = (userInfo: UserInfo) => {
    const { email, given_name, family_name } = userInfo;

    mixPanelServiceInstance.track(mixPanelEvents.LOGOUT, {
      $email: email,
      $distinct_id: email,
      $first_name: given_name,
      $last_name: family_name,
    });
    mixPanelServiceInstance.resetAfterSignOut();
  };

  if (loggingOut) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-80">
        <Loader className="animate-spin h-10 w-10 text-black" />
        <p className="mt-4 text-lg text-black">Logging you out...</p>
      </div>
    );
  }

  return (
    <div className="flex py-3 pl-3 pe-5 w-screen justify-between border-b border-borderGray border-solid fixed bg-white-100 z-10">
      <div className="flex items-center gap-x-3">
      {(isValidator === isReviewer) && (
        !isDrawerOpen ? (
          <div
            className="rounded-2xl border border-solid border-black p-2"
            onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          >
            <img src={menu} className="h-3.5 w-3.5" alt="Menu Icon" />
          </div>
        ) : (
          <img
            src={menuCrossIcon}
            role="button"
            onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            alt="Close Icon"
          />
        )
      )}
        <img src={logo} alt="Logo" className="h-9" />
      </div>

      <div className="flex items-center gap-x-2">
        {/* 
        Note : Incase needed in future
        {userInfo && (
          <Avatar className="inline-flex size-[45px] select-none items-center justify-center overflow-hidden rounded-full border-2 align-middle">
            <AvatarFallback className="leading-1 flex size-full items-center justify-center bg-white text-[16px] font-medium">
              {getNameInitials(userInfo?.firstName)}
            </AvatarFallback>
          </Avatar>
        )} */}
        <Button onClick={onLogout} variant="ghost" size="3">
          <span className="mr-1">
            <img src={logOutIcon} />
          </span>
          Logout
        </Button>
      </div>

      <CommonModal
        modalConfig={{
          title: 'Are you sure you want to log out?',
          isOpen: modal,
          onClose: () => setModal(false),
          handleSubmit: () => {
            setLoggingOut(true);
            setTimeout(() => {
              logout();
              setLoggingOut(false);
              setModal(false);
            }, 1000);
          },
          btn1text: 'Cancel',
          btn2text: 'Log out',
        }}
      />
    </div>
  );
};

export default Header;
